import { createSelector } from 'reselect';

import { selectIsCalltrackingEnabled } from '../calltracking';
import { selectIsAuctionSelected } from '../auction';

export const selectActiveAdditionalIds = createSelector(
  [state => selectIsAuctionSelected(state), selectIsCalltrackingEnabled],
  (isAuctionSelected, isCalltrackingEnabled): Array<string> => {
    const services = [];

    if (isAuctionSelected) {
      services.push('auction');
    }

    if (isCalltrackingEnabled) {
      services.push('calltracking');
    }

    return services;
  },
);
